
export const getLowestNonZeroWholesale = (wholesaleCosts: (number | null)[]): number => {
    const filtered = wholesaleCosts.filter(
        (wholesaleCost) => wholesaleCost && wholesaleCost > 0
    )
    if (filtered.length === 0) {
        return 0
    }
    return Math.min(...filtered)
};